import { Component, Input, OnInit } from '@angular/core';
import {HygrometerDailyData} from '@dmonitor/shared/response/sensor/hygrometer';

@Component({
  selector: 'hygrometer-dailydata',
  templateUrl: 'dailydata.component.pug',
  styleUrls: ['dailydata.component.sass'],
})
export class DailydataComponent implements OnInit {
  @Input() DailyData: HygrometerDailyData[] = [

  ];
  public expanded = true;
  public ngOnInit(): void {
  }
  public expandItem(item): void {
    if (this.expanded) {
      this.expanded = false;
    } else {
      this.expanded = true;
    }
  }
}
